import { OperatorFunction, Observable, ReplaySubject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';


export function log<T>(message: string = ''): OperatorFunction<T, T> {
  return tap(e => console.log(message, e));
}

export function untilComponentDestroyed<T>(
  component: any
): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>) =>
    source.pipe(takeUntil(getOrCreateComponentDestroyedObservable(component)));
}

function getOrCreateComponentDestroyedObservable(component: any): Observable<true> {
  if (!component.__componentDestroyed$) {
    component.__componentDestroyed$ = new ReplaySubject<true>();
  }
  return component.__componentDestroyed$.asObservable();
}

export function componentDestroyed(component: any): void {
  if (component.__componentDestroyed$) {
    component.__componentDestroyed$.next(true);
    // TODO: Not needed
    // component.__componentDestroyed$.complete();
    delete component.__componentDestroyed$;
  }
}